import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 mb-4 [ JS_yourAddress_scrollTo ]" };
const _hoisted_2 = { class: "col-12 bg-white border rounded pt-3" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "row border-bottom mb-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "font7 mb-2" }, "Schritt 1 von 3"),
        /*#__PURE__*/ _createElementVNode("h2", { class: "h5 mb-3" }, "Deine Adresse")
    ])
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_address_form = _resolveComponent("address-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.current_address)
                ? (_openBlock(), _createBlock(_component_address_form, {
                    key: 0,
                    id: "shipping_address_red",
                    "with-company": false,
                    modelValue: _ctx.current_address,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.current_address) = $event)),
                    onFinishChange: _ctx.finishAddressChange
                }, null, 8, ["modelValue", "onFinishChange"]))
                : _createCommentVNode("", true)
        ])
    ]));
}
